import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from './contexts/AuthContext';
import { useThemeMode } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader';
import LoaderDemo from './components/LoaderDemo';
import Home from './pages/Home';
import Login from './pages/Login';
import SubmitProject from './pages/SubmitProject';
import DashboardInvestor from './pages/DashboardInvestor';
import DashboardIssuer from './pages/DashboardIssuer';
import AdminPanel from './pages/AdminPanel';
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import KYC from './pages/KYC';
import AdminRoute from './components/AdminRoute';
import Web3Background from './components/Web3Background';

const App = () => {
  const { user, loading, isAuthenticated } = useAuth();
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  useEffect(() => {
    console.log('App State:', { isAuthenticated, user, loading });
  }, [isAuthenticated, user, loading]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: isDark
            ? 'linear-gradient(135deg, #0B1120 0%, #1E3A8A 100%)'
            : 'linear-gradient(135deg, #F8FAFC 0%, #E0E7FF 100%)',
        }}
      >
        <Loader
          size={100}
          variant="walk"
          text="Initializing Sebear..."
        />
      </Box>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Web3 Animated Background - blockchain icons & real estate elements */}
      <Web3Background />
      
      <Navbar />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/submit" element={<SubmitProject />} />
          <Route path="/loader-demo" element={<LoaderDemo />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route 
            path="/dashboard/investor" 
            element={isAuthenticated && user ? <DashboardInvestor /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/dashboard/issuer" 
            element={isAuthenticated && user ? <DashboardIssuer /> : <Navigate to="/login" />} 
          />
          <Route
            path="/profile"
            element={isAuthenticated && user ? <Profile /> : <Navigate to="/login" />}
          />
          <Route
            path="/kyc"
            element={isAuthenticated && user ? <KYC /> : <Navigate to="/login" />}
          />
          <Route 
            path="/dashboard/admin" 
            element={isAuthenticated && user ? <DashboardInvestor /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App; 